/* eslint-disable no-console */

import { getFeedbacks } from '../api/v1/feedback';
import { FETCH_FEEDBACKS } from '../constants/actionTypes';

export const fetchFeedbacks = () => (dispatch, start) => {
  start(FETCH_FEEDBACKS);
  return getFeedbacks().then(response => {
    return { value: response.data };
  });
};



// WEBPACK FOOTER //
// ./src/actions/feedback.js